"use client";

import { AnimatePresence, motion } from "framer-motion";
import { useJobWizardStore } from "@/features/jobs/store/job-store";
import { StepDetails } from "./step-details";
import { StepStages } from "./step-stages";
import { StepImport } from "./step-import";
import { StepComplete } from "./step-complete";

export function StepContent() {
  const { step } = useJobWizardStore();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={step}
        className="h-full"
        style={step !== 2 ? { overflowY: "auto" } : undefined}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -20 }}
        transition={{ duration: 0.15 }}
      >
        {step === 1 && <StepDetails />}
        {step === 2 && <StepStages />}
        {step === 3 && <StepImport />}
        {step === 4 && <StepComplete />}
      </motion.div>
    </AnimatePresence>
  );
}
